export interface WeekDayAvailability {
  available: AvailabilityLevel;
  startTime?: string; //HH:MM
  endTime?: string;
}

export type AvailabilityLevel = "YES" | "NO" | "PARTIAL";

export const allAvailabilityLevels: AvailabilityLevel[] = [
  "YES",
  "NO",
  "PARTIAL",
];

export function availabilityLevelFromString(str: string): AvailabilityLevel {
  if (allAvailabilityLevels.includes(str as AvailabilityLevel)) {
    return str as AvailabilityLevel;
  }
  throw new Error(`Unknown AvailabilityLevel: ${str}`);
}
